import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  loanAmount?: number;
  pmi?: number;
}

export const calculatePmiPercentage = (
  form: FormInstance,
  loanIndex: string | number,
  {
    loanAmount,
    pmi
  }: FieldValues = {}
): number => {
  const loanAmountValue =
    loanAmount ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'loanAmount', 'value'])) || 0);

  const pmiValue = pmi ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'pmi', 'value'])) || 0);

  if (!loanAmountValue) return 0;

  const percentage = ((pmiValue * 12) / loanAmountValue) * 100;

  return parseFloat(formatAmount(percentage || 0));
}
